import React, { useState } from 'react';
import Button from './Button.js';
import ConfirmModal from './ConfirmModal.js';
/** A button whose action only runs after the user confirms it */
const ConfirmButton = ({ onConfirm, confirmHeader, confirmMessage, ...buttonProps }) => {
    const [confirming, setConfirming] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { ...buttonProps, onClick: (e) => {
                // Confirm buttons often sit inside clickable rows
                e.stopPropagation();
                setConfirming(true);
            } }),
        confirming && (React.createElement(ConfirmModal, { header: confirmHeader, message: confirmMessage, confirmLabel: buttonProps.children ?? buttonProps.value, onCancel: () => setConfirming(false), onConfirm: () => {
                setConfirming(false);
                onConfirm();
            } }))));
};
export default ConfirmButton;
//# sourceMappingURL=ConfirmButton.js.map